function generator(routerMap) {
  return routerMap.map(item => {
    let component = null;
    component = item.component ? () => import(`@/views/${item.component}`) : '';
    const currentRouter = {
      path: item.path || '',
      name: item.name || '',
      component: component,
      meta: item.meta ? { title: item.meta.title, icon: item.meta.icon || undefined, isHidden: item.meta.isHidden || false } : ''
    }
    item.redirect && (currentRouter.redirect = item.redirect)
    if (item.children && item.children.length > 0) {
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}
const permission = {
  state: {
    asyncRoutes: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.asyncRoutes = routers
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const routerMap = data;
        const accessedRouters = generator(routerMap)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
  }
}

export default permission